import { EmailCaptureForm as DSEmailCaptureForm } from '@mc/educator-design-system'
import { Trans, useTranslation } from '@mc/i18n'
import { LEGAL_URLS } from '../../constants/legalUrls'
import { useFireEvent } from '../../tracking/educatorTracking'
import { isValidEmail } from '../../utils/validation'

interface EmailCaptureFormProps {
  location?:
    | 'email form'
    | 'signup form'
    | 'program guide modal'
    | 'stay informed'
  descriptionClassName?: string
  className?: string
}

export const EmailCaptureForm = ({
  location = 'signup form',
  descriptionClassName,
  className,
}: EmailCaptureFormProps) => {
  const { t } = useTranslation('@mc/educator')
  const fireEvent = useFireEvent()

  return (
    <DSEmailCaptureForm
      description={t('enrollment.admissions.emailForm.description')}
      placeholder={t('enrollment.admissions.emailForm.placeholder')}
      submitLabel={t('enrollment.admissions.emailForm.submitLabel')}
      consentText={t('enrollment.admissions.emailForm.consent')}
      termsContent={
        <Trans
          i18nKey='enrollment.admissions.emailForm.terms'
          components={{
            termsLink: (
              <a
                href={LEGAL_URLS.termsOfService}
                target='_blank'
                rel='noopener noreferrer'
                className='text-white underline'
              />
            ),
            privacyLink: (
              <a
                href={LEGAL_URLS.privacy}
                target='_blank'
                rel='noopener noreferrer'
                className='text-white underline'
              />
            ),
          }}
        />
      }
      invalidEmailError={t('enrollment.admissions.emailForm.invalidEmail')}
      termsRequiredError={t('enrollment.admissions.emailForm.termsRequired')}
      successMessage={t('enrollment.admissions.emailForm.successMessage')}
      onSubmit={(email, agreedToUpdates) =>
        fireEvent('educatorEmailCaptured', {
          email,
          location,
          action: 'submit',
          marketing_consent: agreedToUpdates,
        })
      }
      validateEmail={isValidEmail}
      className={className}
      descriptionClassName={descriptionClassName}
    />
  )
}
